module.exports = __webpack_public_path__ + "static/media/map-teaser.616ef327.png";